import { render } from "./sidebarPill.vue?vue&type=template&id=6d39c763&scoped=true"
import script from "./sidebarPill.vue?vue&type=script&lang=js"
export * from "./sidebarPill.vue?vue&type=script&lang=js"

import "./sidebarPill.vue?vue&type=style&index=0&id=6d39c763&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d39c763"]])

export default __exports__